import type { IconSvgObject } from './types';

const EditOffIcon: IconSvgObject = [
  ["path", { d: "M12 6L18 12M10.9994 7L15.292 2.70715C15.6825 2.31661 16.3157 2.3166 16.7062 2.70713L21.292 7.29289C21.6825 7.68342 21.6825 8.31658 21.292 8.70711L17 12.9991M15 14.9991L7.99908 22H2V16L8.99954 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EditOffIcon;
